__turbopack_context__.v({
  "questionText": "styles-module-scss-module__JpgbIa__questionText",
  "questionText__input": "styles-module-scss-module__JpgbIa__questionText__input",
});
